import { FlowComponent } from "@forms/schema";

type TraversableComponent = {
  component?: string;
  action?: unknown;
  fields?: unknown[];
  components?: unknown[];
};

function asTraversableComponent(component: unknown): TraversableComponent | undefined {
  if (!component || typeof component !== "object") {
    return undefined;
  }

  return component as TraversableComponent;
}

function getNestedComponents(component: TraversableComponent): unknown[] {
  const fields = Array.isArray(component.fields) ? [ ...component.fields ].reverse() : [];
  const components = Array.isArray(component.components) ? [ ...component.components ].reverse() : [];
  return [ ...components, ...fields ];
}

function processNode(node: unknown, stack: unknown[]): string | undefined {
  const typed = asTraversableComponent(node);
  if (!typed) {
    return undefined;
  }
  if (typed.component === "summary" && typeof typed.action === "string") {
    return typed.action;
  }
  getNestedComponents(typed).forEach((child) => stack.push(child));
  return undefined;
}

function getSummaryActionFromComponent(component: unknown): string | undefined {
  const stack: unknown[] = [ component ];

  while (stack.length) {
    const action = processNode(stack.pop(), stack);
    if (action) {
      return action;
    }
  }

  return undefined;
}

export function getSummaryActionFromFlow(mappedFlow: FlowComponent): string | undefined {
  const allSectionComponents = mappedFlow.forms
    .flatMap((form) => form.content.sections)
    .flatMap((section) => section.fieldsets);

  for (const sectionComponent of allSectionComponents) {
    const action = getSummaryActionFromComponent(sectionComponent);
    if (action) {
      return action;
    }
  }

  return undefined;
}
